import { combineReducers } from "@reduxjs/toolkit";

import { repairCatalogsReducer } from "./repairCatalogSlice";

export const repairReducer = combineReducers({
  catalogs: repairCatalogsReducer,
});
